
import { defineComponent } from "vue";
import { RouterLink, useRouter } from "vue-router";
import { useStore } from "vuex";

export default defineComponent({
  name: "LoginForm",
  components: {
    RouterLink,
  },
  setup() {
    const router = useRouter();
    const store = useStore();

    if (store.getters.isLoggedIn) {
      router.push("/app-start");
    }

    return {
      router,
      store,
    };
  },
  data() {
    return {
      email: "",
      password: "",
      errorMessage: "",
    };
  },
  methods: {
    async handleLogin() {
      const requestOptions = {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({ email: this.email, password: this.password }),
      };

      // Send the POST request
      const response = await fetch("/api/login", requestOptions as any);

      // Check if the request was successful
      if (!response.ok) {
        const data = await response.json(); // We move this line inside the if block
        this.errorMessage =
          data.message || "Failed to login. Please check your credentials.";
        return;
      }

      // If the response was successful, we update the application state and redirect the user
      this.store.dispatch("login");
      this.router.push("/app-start");
    },
  },
});
